
import { useMemo } from 'react';

import { useBalanceStore } from '@/entities/balance';
import { useSpace } from '@/entities/teamspace';
import { useSettings } from '@/entities/user/currentUser';

import { useIsSpaceOwner } from './useIsSpaceOwner';

export const useCanInviteMember = (membersCount?: number) => {
  const isOwner = useIsSpaceOwner();
  const { data: space } = useSpace();
  const settings = useSettings();
  const { hasActiveSubscription } = useBalanceStore();

  return useMemo(() => {
    if (!isOwner || !hasActiveSubscription || !space) return false;

    const { space_extra_seats, spaces } = settings.scope_settings.available_features;

    const userLimit = spaces.metadata.user_limit ?? 0;
    const extraSeats = space_extra_seats?.metadata?.quantity ?? 0;

    // Если спейсы не включены в план и extra seats не куплены — инвайт невозможен
    if (!spaces.enabled && extraSeats === 0) return false;

    // Минимум 1 место всегда под владельца; докупленные места добавляются сверх этого
    const totalAllowedSeats = Math.max(userLimit, 1) + extraSeats;

    const currentOccupiedSeats = membersCount ?? (space.members?.length ?? 0) + (space.invites?.length ?? 0);

    return currentOccupiedSeats < totalAllowedSeats;
  }, [hasActiveSubscription, isOwner, membersCount, settings.scope_settings.available_features, space]);
};
